import { render, staticRenderFns } from "./MyCompanyTaxLevelsNew.vue?vue&type=template&id=32f54ebe&"
import script from "./MyCompanyTaxLevelsNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyTaxLevelsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports